import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useFileDropZoneStyles = makeStyles(({ spacing, palette }) => {
  return createStyles({
    dropZoneWrapper: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      alignItems: 'center',
      padding: spacing(4),
      borderWidth: 2,
      borderRadius: 2,
      borderColor: palette.divider,
      borderStyle: 'dashed',
      backgroundColor: palette.grey[100],
      color: palette.text.disabled,
      outline: 'none',
      transition: 'border .24s ease-in-out',
    },
    or: {
      marginBottom: spacing(1.5),
    },
    wrapper: {
      padding: spacing(3),
      marginTop: spacing(0.5),
      borderTop: `${spacing(0.3)} solid ${palette.divider}`,
    },
  });
});
export default useFileDropZoneStyles;
